import { computed } from 'vue';

import { i18n } from '@/i18n';
import { useAccountsService } from '@/modules/Accounts/services/AccountsService';
import { useUserService } from '@/modules/User/services/UserService';

import { featureFlags } from '@/modules/FeatureFlags';

export const useUserMenu = () => {
  const { t } = i18n.global;
  const accountsService = useAccountsService();
  const authService = useUserService();

  const isSectionVisible = computed(
    () => accountsService.isValidAccountSelected && authService.isValidUser,
  );

  return computed(() => [[
    {
      to: '/properties',
      text: t('Properties'),
      visible: isSectionVisible.value,
    },
    {
      to: '/pages',
      text: t('Pages'),
      visible: isSectionVisible.value && featureFlags.flags.value['self-mapping-enabled'],
    },
    {
      to: '/corporate',
      text: t('Corporate Sites'),
      visible: isSectionVisible.value,
    },
    {
      to: '/brands',
      text: t('Brands'),
      visible: isSectionVisible.value,
    },
    {
      to: '/clusters',
      text: t('Clusters'),
      visible: isSectionVisible.value,
    },
    {
      to: '/team',
      text: t('Team'),
      visible: accountsService.isOwnerOrAdmin && authService.isValidUser,
    },
    {
      to: '/billing',
      text: t('Billing'),
      visible: accountsService.isOwnerOrAdmin
        && authService.isValidUser
        && featureFlags.flags.value.salesforce,
    },
    {
      to: '/settings',
      text: t('Settings'),
      visible: accountsService.isOwnerOrAdmin,
    },
  ].filter(el => el.visible)]);
};
